export default "__VITE_ASSET__BXk8zrjq__"